export enum FETCH_ERROR {
  NOT_FOUND = "not_found",
  UNAUTHORIZED = "unauthorized",
}
